/**
 * CTR Combo Ingredients — scroll controls
 */
(function () {
  'use strict';

  const SELECTOR = '.ctr-combo-ingredients';

  function initSection(section) {
    if (!section || section.dataset.ciBound === 'true') return;
    section.dataset.ciBound = 'true';

    const track = section.querySelector('[data-ci-track]');
    const prevBtn = section.querySelector('[data-ci-prev]');
    const nextBtn = section.querySelector('[data-ci-next]');
    const dots = Array.from(section.querySelectorAll('[data-ci-dot]'));
    const cards = track ? Array.from(track.querySelectorAll('.ctr-combo-ingredients__card')) : [];

    if (!track || cards.length === 0) return;

    const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)');

    function scrollStep() {
      const card = cards[0];
      if (!card) return track.clientWidth * 0.8;

      const styles = window.getComputedStyle(track);
      const gap = parseFloat(styles.columnGap || styles.gap) || 24;

      return card.getBoundingClientRect().width + gap;
    }

    function maxIndex() {
      const step = scrollStep();
      if (step <= 0) return 0;

      return Math.max(0, Math.ceil((track.scrollWidth - track.clientWidth) / step));
    }

    function currentIndex() {
      const step = scrollStep();
      if (step <= 0) return 0;

      return Math.max(0, Math.min(Math.round(track.scrollLeft / step), maxIndex()));
    }

    function updateControls() {
      const index = currentIndex();
      const max = maxIndex();
      const canScroll = track.scrollWidth > track.clientWidth + 4;
      const atStart = track.scrollLeft <= 4;
      const atEnd = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;

      if (prevBtn) {
        prevBtn.disabled = !canScroll || atStart;
        prevBtn.setAttribute('aria-disabled', prevBtn.disabled ? 'true' : 'false');
      }

      if (nextBtn) {
        nextBtn.disabled = !canScroll || atEnd;
        nextBtn.setAttribute('aria-disabled', nextBtn.disabled ? 'true' : 'false');
      }

      dots.forEach((dot, i) => {
        const visible = i <= max;
        const active = visible && i === index;

        dot.hidden = !visible;
        dot.classList.toggle('is-active', active);
        dot.setAttribute('aria-current', active ? 'true' : 'false');
      });
    }

    function goTo(index) {
      const clamped = Math.max(0, Math.min(index, maxIndex()));
      const behavior = prefersReducedMotion.matches ? 'auto' : 'smooth';

      track.scrollTo({ left: clamped * scrollStep(), behavior });
    }

    prevBtn?.addEventListener('click', () => goTo(currentIndex() - 1));
    nextBtn?.addEventListener('click', () => goTo(currentIndex() + 1));

    dots.forEach((dot, i) => {
      dot.addEventListener('click', () => goTo(i));
    });

    let scrollRaf = 0;

    track.addEventListener(
      'scroll',
      () => {
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(updateControls);
      },
      { passive: true }
    );

    window.addEventListener('resize', updateControls, { passive: true });
    updateControls();
  }

  function initAll() {
    document.querySelectorAll(SELECTOR).forEach(initSection);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector?.(SELECTOR) || event.target.closest?.(SELECTOR);

    if (section) {
      section.dataset.ciBound = '';
      initSection(section);
    }
  });
})();